export const isTrackingEnabled = () => process.env.NODE_ENV !== "development";

export const trackEvent = (event: string, params = {}) => {
  if (!isTrackingEnabled()) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...params,
  });
};